import {Filter} from "@/dto/Pageable";
import QueryUtils from "@/utils/QueryUtils";
import axios, {AxiosResponse} from "axios";
import Page from "@/dto/taxation/Page";
import {
    CreateInvoiceContactPayload,
    CreateServiceRecordPayload, InvoiceContact, InvoiceContactFilter, Locations, ServiceRecordDTO, ServiceRecordFilter,
    UpdateServiceRecordPayload
} from "@/components/payroll/business/services/ServiceDTO";
import {SERVICE_LOG_ENDPOINT} from "@/constants/endpoints";
import authHeader from "@/services/auth-header";
import CollectionUtils from "@/utils/CollectionUtils";
import AddressDTO from "@/dto/AddressDTO";
import Workspaces from "@/state/Workspaces";

class ServiceLogOrchestrator {

    public getPageByFilter<T extends Filter>(filter: T) {
        const query = QueryUtils.objectToQueryString(filter);
        return axios.get<Page<ServiceRecordDTO>>(`${SERVICE_LOG_ENDPOINT}${query}`, {headers: authHeader()})
    }

    public getAllByFilter(filter: ServiceRecordFilter) {
        const query = QueryUtils.objectToQueryString(filter);
        return axios.get<Array<ServiceRecordDTO>>(`${SERVICE_LOG_ENDPOINT}/all${query}`, {headers: authHeader()})
    }

    public createLog(payload: CreateServiceRecordPayload) {
        return axios.post<ServiceRecordDTO>(`${SERVICE_LOG_ENDPOINT}`, payload, {headers: authHeader()})
    }

    public updateLog(payload: UpdateServiceRecordPayload) {
        return axios.put<void>(`${SERVICE_LOG_ENDPOINT}`, payload, {headers: authHeader()})
    }

    public disableLog(serviceId: number | string | null, assigneeId: number | string | null) {
        return axios.delete<void>(`${SERVICE_LOG_ENDPOINT}/${assigneeId}/${serviceId}`, {headers: authHeader()})
    }

    public getLocationsByExecutorId(executorId: number, contactId: number | undefined | null): Promise<AxiosResponse<Locations>> {
        const query = CollectionUtils.createPathParamsMap(
            ["executorId", executorId],
            ["contactId", contactId],
        );
        return axios.get<Locations>(`${SERVICE_LOG_ENDPOINT}/locations${QueryUtils.toQueryString(query)}`, {headers: authHeader()})
    }

    public createLocation(address: AddressDTO) {
        return axios.post<AddressDTO>(`${SERVICE_LOG_ENDPOINT}/locations`, address, {headers: authHeader()})
    }

    public getRecentContactsByFilter(createdById = Workspaces.getCurrent.userId) {
        return axios.get<Array<InvoiceContact>>(`${SERVICE_LOG_ENDPOINT}/contacts/recent/${createdById}`, {headers: authHeader()})
    }

    public getContactsByFilter(filter: InvoiceContactFilter) {
        const query = QueryUtils.objectToQueryString(filter)
        return axios.get<Page<InvoiceContact>>(`${SERVICE_LOG_ENDPOINT}/contacts${query}`, {headers: authHeader()})
    }

    public createContact(req: CreateInvoiceContactPayload) {
        return axios.post<InvoiceContact>(`${SERVICE_LOG_ENDPOINT}/contacts`, req, {headers: authHeader()})
    }

}

export default new ServiceLogOrchestrator()